export const DRIVE_ROOT_NAME = 'My Collections';
